import './WhyChooseUs.css';

const FEATURES = [
  {
    title: 'Scientific Expertise',
    desc: 'Experienced scientific professionals across BE, pharmacovigilance and regulatory affairs.',
  },
  {
    title: 'Global Regulatory Reach',
    desc: 'Submissions handled for US FDA, EMA, CDSCO, MHRA, GCC, ASEAN and more.',
  },
  {
    title: 'End-to-End Support',
    desc: 'From protocol development to final study report and dossier filing.',
  },
  {
    title: 'Client-Centric Approach',
    desc: 'Reliable, high-quality solutions tailored to your product and market.',
  },
];

function LeafBadge() {
  return (
    <span className="feature__icon">
      <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
        <path
          d="M12 3C7 5 4 10 4 14c0 4 3.6 7 8 7s8-3 8-7c0-4-3-9-8-11Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path d="M12 6v15" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </span>
  );
}

function WhyChooseUs() {
  const [left, right] = [FEATURES.slice(0, 2), FEATURES.slice(2)];

  return (
    <section className="section section--alt" id="why-us">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Why Choose Us</span>
          <h2 className="section-title">Let&rsquo;s Build a Faster Path to Compliance Together</h2>
        </div>

        <div className="why">
          <div className="why__col">
            {left.map((feature) => (
              <div className="feature" key={feature.title}>
                <LeafBadge />
                <div>
                  <h3 className="feature__title">{feature.title}</h3>
                  <p className="feature__desc">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="why__visual" aria-hidden="true">
            <div className="why__ring" />
            <svg viewBox="0 0 64 64" fill="none" className="why__leaf">
              <path
                d="M32 4C18 10 8 24 8 38c0 12 10 22 24 22s24-10 24-22C56 24 46 10 32 4Z"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="M32 14c-8 4-14 13-14 22 0 7 6 12.5 14 12.5S46 43 46 36c0-9-6-18-14-22Z"
                stroke="currentColor"
                strokeWidth="1.4"
                opacity="0.6"
              />
            </svg>
          </div>

          <div className="why__col">
            {right.map((feature) => (
              <div className="feature" key={feature.title}>
                <LeafBadge />
                <div>
                  <h3 className="feature__title">{feature.title}</h3>
                  <p className="feature__desc">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
